var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['cp-mask', _vm.show ? 'show' : ''],on:{"click":function($event){return _vm.handleClose($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }